/* tslint:disable */
/* eslint-disable */
export enum NonResidentVisaTypeEnum {
  None = 'None',
  WorkingVisa = 'WorkingVisa',
  OtherVisa = 'OtherVisa',
  NoVisaRequired = 'NoVisaRequired'
}
